import { render, staticRenderFns } from "./TeamDialog.vue?vue&type=template&id=0d60e4e3&scoped=true"
import script from "./TeamDialog.vue?vue&type=script&lang=js"
export * from "./TeamDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamDialog.vue?vue&type=style&index=0&id=0d60e4e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60e4e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d60e4e3')) {
      api.createRecord('0d60e4e3', component.options)
    } else {
      api.reload('0d60e4e3', component.options)
    }
    module.hot.accept("./TeamDialog.vue?vue&type=template&id=0d60e4e3&scoped=true", function () {
      api.rerender('0d60e4e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Incubator/TeamDialog.vue"
export default component.exports